import { List } from 'immutable';
import { buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';
import { buildUnitResourcesKey } from './model';

const method = 'GET';
const buildUnitResourcesUrl = (groupId, unitId) =>
  buildUrl(`/groups/${groupId}/units/${unitId}/resources`);

export function getUnitResources(state, groupId, unitId) {
  const slice = state.get('rootReducer').get('unitResources');
  if (! slice) {
    return new List();
  }
  return slice.get(buildUnitResourcesKey(groupId, unitId)) || new List();
}

export function isLoadingUnitResources(state, groupId, unitId) {
  const callState = ApiCall.find(state, {
    method,
    url: buildUnitResourcesUrl(groupId, unitId),
  });

  return ApiCall.State.isValue(callState) && ApiCall.State.isLoading(callState);
}



// WEBPACK FOOTER //
// ./data/UnitResources/accessors.js